import React from 'react'

function SortOrder(props) {
  const { checkPopularMovie, handlePepularMovie, sortPopularMoviesReset, statusType } = props
  return (
    <div className='agerestriction'>
      <label>Popular Movie</label>
      <div className='d-flex'>
        <select
          disabled={statusType === 'draft'}
          defaultValue={''}
          value={checkPopularMovie}
          onChange={e => handlePepularMovie(e)}
          required
          name='select'
          id='languages'
        >
          <option value='' disabled selected>
            Popular Movie
          </option>
          <option value='true' selected={checkPopularMovie === 'true'}>
            True
          </option>
          <option value='false' selected={checkPopularMovie === 'false'}>
            False
          </option>
        </select>
        <button
          style={{ padding: '1px 7px', marginLeft: '4px' }}
          onClick={sortPopularMoviesReset}
          className='btn btn-primary'
        >
          x
        </button>
      </div>
    </div>
  )
}

export default SortOrder
